import { MasterLayout } from '@/layouts/master/master-layout'
import PlanDetailPage from '@/pages/master/commerce/plans/plan-detail-page'
import PlanFormPage from '@/pages/master/commerce/plans/plan-form-page'
import PlansPage from '@/pages/master/commerce/plans/plans-page'
import PlanTiersPage from '@/pages/master/commerce/plan-tiers/plan-tiers-page'
import PlanTierFormPage from '@/pages/master/commerce/plan-tiers/plan-tier-form-page'
import FinancialSettingsPage from '@/pages/master/commerce/settings/financial-settings-page'
import DunningSettingsPage from '@/pages/master/commerce/settings/dunning-settings-page'
import StoragePolicyPage from '@/pages/master/commerce/settings/storage-policy-page'
import CompanyDetailPage from '@/pages/master/core/organizations/company-detail-page'
import OrganizationDetailPage from '@/pages/master/core/organizations/organization-detail-page'
import OrganizationsPage from '@/pages/master/core/organizations/organizations-page'
import SystemModulesPage from '@/pages/master/core/system-modules/system-modules-page'
import SystemModuleFormPage from '@/pages/master/core/system-modules/system-module-form-page'
import PoliciesListPage from '@/pages/master/core/policies/policies-list-page'
import PolicyFormPage from '@/pages/master/core/policies/policy-form-page'
import UsersMasterPage from '@/pages/master/core/users/users-master-page'
import AiUsagePage from '@/pages/master/core/ai-usage/ai-usage-page'
import BlockedIpsPage from '@/pages/master/core/security/blocked-ips-page'
import PlatformAccountPage from '@/pages/master/core/platform-account/platform-account-page'
import IntegrationsPage from '@/pages/master/core/integrations/integrations-page'
import WhatsappSystemTemplatesPage from '@/pages/master/core/whatsapp-system-templates/whatsapp-system-templates-page'
import SystemAnnouncementsPage from '@/pages/master/core/system-announcements/system-announcements-page'
import TussListPage from '@/pages/master/core/tuss/tuss-list-page'
import TussUnifyPage from '@/pages/master/core/tuss/tuss-unify-page'
import CatalogFusionPage from '@/pages/master/core/tuss/catalog-fusion-page'
import SupportPage from '@/pages/support/support-page'
import { Route, Routes } from 'react-router-dom'

const PublicRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<MasterLayout />}>
                <Route path="/security/users" element={<UsersMasterPage />} />
                <Route path="/security/blocked-ips" element={<BlockedIpsPage />} />
                <Route path="/platform/ai-usage" element={<AiUsagePage />} />
                <Route path="/platform-account" element={<PlatformAccountPage />} />
                <Route path="/atendimento/integrations" element={<IntegrationsPage />} />
                <Route
                    path="/messaging/system-templates"
                    element={<WhatsappSystemTemplatesPage />}
                />
                <Route path="/system-announcements" element={<SystemAnnouncementsPage />} />
                <Route path="/bookings/tuss" element={<TussListPage />} />
                <Route path="/bookings/tuss/unify" element={<TussUnifyPage />} />
                <Route path="/bookings/catalog-fusion" element={<CatalogFusionPage />} />
                <Route path="/plan-tiers" element={<PlanTiersPage />} />
                <Route path="/plan-tiers/new" element={<PlanTierFormPage />} />
                <Route
                    path="/plan-tiers/edit/:id"
                    element={<PlanTierFormPage />}
                />
                <Route path="/plans" element={<PlansPage />} />
                <Route path="/plans/new" element={<PlanFormPage />} />
                <Route
                    path="/plans/edit/:id"
                    element={<PlanFormPage />}
                />
                <Route
                    path="/plans/:id"
                    element={<PlanDetailPage />}
                />
                <Route
                    path="/settings/financial"
                    element={<FinancialSettingsPage />}
                />
                <Route
                    path="/settings/dunning"
                    element={<DunningSettingsPage />}
                />
                <Route
                    path="/settings/storage"
                    element={<StoragePolicyPage />}
                />
                <Route
                    path="/organizations"
                    element={<OrganizationsPage />}
                />
                <Route
                    path="/organizations/:id"
                    element={<OrganizationDetailPage />}
                />
                <Route
                    path="/organizations/:orgId/companies/:companyId"
                    element={<CompanyDetailPage />}
                />
                <Route
                    path="/system-modules"
                    element={<SystemModulesPage />}
                />
                <Route
                    path="/system-modules/new"
                    element={<SystemModuleFormPage />}
                />
                <Route
                    path="/system-modules/edit/:id"
                    element={<SystemModuleFormPage />}
                />
                <Route
                    path="/policies"
                    element={<PoliciesListPage />}
                />
                <Route
                    path="/policies/new"
                    element={<PolicyFormPage />}
                />
                <Route
                    path="/policies/:id"
                    element={<PolicyFormPage />}
                />
                <Route path="/support" element={<SupportPage />} />
            </Route>
        </Routes>
    )
}

export default PublicRoutes
